import { RouteConfig } from 'vue-router'
import { membershipRouteNames } from '@/routes/constants/location'
import { requireAuthAndLocation } from '../auth'

const membershipRoot = () => import('@/pmd/pages/membership/MembershipRoot.vue')

const membershipBuilder = () =>
  import('@/pmd/pages/membership/MembershipMicroApp.vue')

const membershipBuilderV2 = () =>
  import('@/pmd/pages/membership/MembershipBuilderV2.vue')

const certificatesRoot = () =>
  import('@/pmd/pages/certificates/CertificatesRoot.vue')

const certificatesBuilder = () =>
  import('@/pmd/pages/certificates/CertificatesBuilder.vue')

const communitiesRoot = () =>
  import('@/pmd/pages/communities/CommunitiesRoot.vue')

const communitiesBuilder = () =>
  import('@/pmd/pages/communities/CommunitiesBuilder.vue')

const goKollabRoot = () =>
  import('@/pmd/pages/gokollab/GoKollabRoot.vue')

const goKollabBuilder = () =>
  import('@/pmd/pages/gokollab/GoKollabBuilder.vue')

const clientPortalBuilder = () =>
  import('@/pmd/pages/client-portal/ClientPortalMicroApp.vue')

export const membershipRoutes: RouteConfig[] = [
  {
    path: 'memberships/courses',
    component: membershipRoot,
    name: membershipRouteNames.default,
    beforeEnter: requireAuthAndLocation,
    children: [
      {
        path: 'dashboard',
        name: membershipRouteNames.courses.dashboard,
        component: membershipBuilder,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'product_blueprints',
        name: membershipRouteNames.courses.productBlueprint,
        component: membershipBuilder,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'products/:product_id/certificates',
        name: membershipRouteNames.courses.productCertificate,
        component: membershipBuilderV2,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'course-importer',
        name: membershipRouteNames.courses.courseImporter,
        component: membershipBuilderV2,
      },
      {
        path: 'products/manage-comments',
        name: membershipRouteNames.courses.membershipManageComments,
        component: membershipBuilderV2,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'products/:id/comments',
        name: membershipRouteNames.courses.membershipProductComments,
        component: membershipBuilderV2,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'categories/:id/edit',
        name: membershipRouteNames.courses.categoriesEdit,
        component: membershipBuilder,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'products/:product_id/product-offers-v2',
        name: membershipRouteNames.courses.productOffersV2,
        component: membershipBuilderV2,
        beforeEnter: requireAuthAndLocation,
      },
       {
        path: 'products/:product_id/product-groups',
        name: membershipRouteNames.courses.productGroups,
        component: membershipBuilderV2,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'products',
        component: membershipBuilder,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: '/',
            name: membershipRouteNames.courses.products.membershipProducts,
            component: membershipBuilder,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'library-order',
            name: membershipRouteNames.courses.products.membershipLibrary,
            component: membershipBuilder,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: ':id*',
            name: membershipRouteNames.courses.products.membershipProductOverview,
            component: membershipBuilder,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: ':id/edit',
            name: membershipRouteNames.courses.products.membershipProductEdit,
            component: membershipBuilder,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: ':id/offers',
            name: membershipRouteNames.courses.products.membershipProductOffers,
            component: membershipBuilder,
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },
      {
        path: 'offers/:id/edit',
        name: membershipRouteNames.courses.offerEdit,
        component: membershipBuilderV2,
      },
      {
        path: 'offers/',
        name: membershipRouteNames.courses.membershipOffers.default,
        component: membershipBuilder,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: ':id/checkout/edit',
            name:
              membershipRouteNames.courses.membershipOffers
                .coursesOfferCustomization,
            component: membershipBuilder,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: ':id/upsell',
            name: membershipRouteNames.courses.membershipOffers.upSellHome,
            component: membershipBuilder,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: ':id*',
            name: membershipRouteNames.courses.membershipOffers.detail,
            component: membershipBuilder,
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },
      {
        path: 'analytics/analytics-assessments/assignment/:id',
        name: membershipRouteNames.courses.assignmentEvaluation,
        component: membershipBuilderV2,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'analytics',
        name: membershipRouteNames.courses.membershipAnalytics.default,
        component: membershipBuilder,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: 'product-progress',
            name:
              membershipRouteNames.courses.membershipAnalytics.productProgress,
            component: membershipBuilder,
            beforeEnter: requireAuthAndLocation,
            children: [
              {
                path: ':id*',
                name:
                  membershipRouteNames.courses.membershipAnalytics
                    .memberProgress,
                component: membershipBuilder,
                beforeEnter: requireAuthAndLocation,
              },
            ],
          },
          {
            path: 'analytics-assessments',
            name: membershipRouteNames.courses.membershipAnalytics.assessment,
            component: membershipBuilder,
            beforeEnter: requireAuthAndLocation,
            children: [
              {
                path: ':assessment_submission_id*',
                name:
                  membershipRouteNames.courses.membershipAnalytics
                    .assessmentSubmission,
                component: membershipBuilder,
                beforeEnter: requireAuthAndLocation,
              },
            ],
          },
        ],
      },
      {
        path: 'create-offers',
        name: membershipRouteNames.courses.offersV2,
        component: membershipBuilderV2,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'offers-list',
        name: membershipRouteNames.courses.offersOverview,
        component: membershipBuilderV2,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'netrevenue-analytics',
        name: membershipRouteNames.courses.membershipNetRevenueAnalytics,
        component: membershipBuilderV2,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'members-analytics',
        name: membershipRouteNames.courses.membershipMembersAnalytics,
        component: membershipBuilderV2,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'themes-overview/:product_id',
        component: membershipBuilderV2,
        name: membershipRouteNames.courses.coursesThemesOverview,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: 'edit/theme/:theme_id',
            name: membershipRouteNames.courses.coursesThemeCustomizer,
            component: membershipBuilderV2,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'edit/template/:template_id',
            name: membershipRouteNames.courses.coursesTemplateCustomizer,
            component: membershipBuilderV2,
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },
      {
        path: 'member-progress/:contact_id',
        name: membershipRouteNames.courses.membershipMembersProgress,
        component: membershipBuilderV2,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'posts/:post_id/edit',
        name: membershipRouteNames.courses.membershipPostEdit,
        component: membershipBuilderV2,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'settings',
        name: membershipRouteNames.courses.membershipSettings.default,
        component: membershipBuilder,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: 'site-details',
            name: membershipRouteNames.courses.membershipSettings.siteDetails,
            component: membershipBuilder,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'custom-domain',
            name: membershipRouteNames.courses.membershipSettings.customDomain,
            component: membershipBuilder,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'email-settings',
            name: membershipRouteNames.courses.membershipSettings.emailSettings,
            component: membershipBuilder,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'app-settings',
            name: membershipRouteNames.courses.membershipSettings.appSettings,
            component: membershipBuilder,
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },
      {
        path: 'categories',
        name: membershipRouteNames.courses.membershipCategories,
        component: membershipBuilder,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: '*',
            name: membershipRouteNames.courses.edit,
            component: membershipBuilder,
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },
      {
        path: 'posts/:id/assignment',
        name: membershipRouteNames.courses.postAssignment,
        component: membershipBuilderV2,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'posts/:id/quiz',
        name: membershipRouteNames.courses.postQuiz,
        component: membershipBuilderV2,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'posts',
        name: membershipRouteNames.courses.membershipPosts.default,
        component: membershipBuilder,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: ':id/*',
            name: membershipRouteNames.courses.membershipPosts.postEdit,
            component: membershipBuilder,
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },
      {
        path: 'themes',
        name: membershipRouteNames.courses.membershipTheme.default,
        component: membershipBuilder,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: '*',
            name: membershipRouteNames.courses.membershipTheme.editTheme,
            component: membershipBuilder,
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },
      {
        path: 'themes-v2',
        name: membershipRouteNames.courses.membershipNewTheme.default,
        component: membershipBuilder,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: ':theme_id/edit/:id',
            name: membershipRouteNames.courses.membershipNewTheme.editV2Theme,
            component: membershipBuilder,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: '*',
            name: membershipRouteNames.courses.membershipNewTheme.editTheme,
            component: membershipBuilder,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: ':id',
            name: membershipRouteNames.courses.membershipNewTheme.productAllTheme,
            component: membershipBuilder,
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },
    ],
  },
  {
    path: 'memberships/certificates',
    component: certificatesRoot,
    name: membershipRouteNames.certificates.default,
    beforeEnter: requireAuthAndLocation,
    children: [
      {
        path: 'create-certificates',
        name: membershipRouteNames.certificates.create,
        component: certificatesBuilder,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: ':certificate_id/edit',
        name: membershipRouteNames.certificates.edit,
        component: certificatesBuilder,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: ':badge_id/create',
        name: membershipRouteNames.certificates.createBadges,
        component: certificatesBuilder,
        beforeEnter: requireAuthAndLocation,
      },
    ],
  },
  {
    path: 'memberships/communities',
    component: communitiesRoot,
    name: membershipRouteNames.communities.default,
    children: [
      {
        path: 'community-groups',
        name: membershipRouteNames.communities.groups,
        component: communitiesBuilder,
      },
      {
        path: 'create-group',
        name: membershipRouteNames.communities.createGroup,
        component: communitiesBuilder,
      },
    ],
  },
  {
    path: 'memberships/gokollab',
    component: goKollabRoot,
    name: membershipRouteNames.gokollab.default,
    children: [
      {
        path: 'activation',
        name: membershipRouteNames.gokollab.activation,
        component: goKollabBuilder,
      },
    ],
  },
  {
    path: 'memberships/communities/clientportal-domain-setup',
    name: membershipRouteNames.communitiesDomainSetup,
    component: clientPortalBuilder,
  },
  {
    path: 'memberships/communities/communities-branded-app',
    name: membershipRouteNames.communitiesBrandedApp,
    component: clientPortalBuilder,
  },
  {
    path: 'memberships/client-portal',
    component: clientPortalBuilder,
    children: [
      {
        path: 'dashboard',
        name: membershipRouteNames.clientPortal.dashboard,
        component: clientPortalBuilder,
      },
      {
        path: 'domain-setup',
        name: membershipRouteNames.clientPortal.domainSetup,
        component: clientPortalBuilder,
      },
      {
        path: 'branding',
        name: membershipRouteNames.clientPortal.branding,
        component: clientPortalBuilder,
      },
      {
        path: 'branded-app',
        name: membershipRouteNames.clientPortal.brandedApp,
        component: clientPortalBuilder,
      },
      {
        path: 'app-permission',
        name: membershipRouteNames.clientPortal.appPermission,
        component: clientPortalBuilder,
      },
      {
        path: 'settings',
        name: membershipRouteNames.clientPortal.settings,
        component: clientPortalBuilder,
      },
      {
        path: 'email-settings',
        name: membershipRouteNames.clientPortal.emailSettings,
        component: clientPortalBuilder,
      },
      {
        path: 'language-settings',
        name: membershipRouteNames.clientPortal.languageSettings,
        component: clientPortalBuilder,
      },
      {
        path: 'chat-widget-settings',
        name: membershipRouteNames.clientPortal.chatWidget,
        component: clientPortalBuilder,
      },
    ],
  },
]
